import React from "react";
import { m as motion } from "../../shared/components/Motion";
import { useHomeData } from "../../shared/hooks";
import {
  containerVariants,
  childVariantsMedium as childVariants,
} from "../../shared/utils";

const Social = ({ socialLinks = null }) => {
  const defaultData = useHomeData();

  // Use passed socialLinks if available, otherwise use hook data
  const displayLinks = socialLinks || defaultData.data?.socialLinks || [];

  return (
    <motion.div
      className="home__social"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {displayLinks.map((link, index) => (
        <motion.a
          title={link.title}
          key={index}
          href={link.href}
          className="home__social-icon"
          target="_blank"
          rel="noopener noreferrer"
          variants={childVariants}
        >
          <i className={link.iconClass}></i>
        </motion.a>
      ))}
    </motion.div>
  );
};

export default Social;
